import { Modal } from "antd";

const AdminLogBodyData = ({ isVisible, onClose, data }) => {
  return (
    <Modal
      title="Body Data"
      open={isVisible}
      onCancel={onClose}
      footer={null}
      width={600}
      styles={{
        body: {
          maxHeight: "60vh",
          overflowY: "auto",
          padding: "12px",
        },
      }}
    >
      <pre style={{
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
        background: "#f5f5f5",
        padding: 12,
        borderRadius: 6,
        margin: 0,
      }}>
        {JSON.stringify(data, null, 2)}
      </pre>
    </Modal>
  );
};

export default AdminLogBodyData;